module.exports = __webpack_public_path__ + "static/img/savebg.788071bd.jpg";